import { BrowserRouter as Router, Switch, Route, Link } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import NewFaqPage from './Views/NewFaqPage';
import HomePage from './Views/HomePage';
import SipPage from './Views/SipPage.jsx';
import TrusteeCertificate from './Views/TrusteeCertificate.jsx';
import ChartComponent from '../src/Components/priceCharts/ChartComponent.jsx';
import 'react-toastify/dist/ReactToastify.css';
import './App.css';
import ComingSoon from './Views/Comingsoon.jsx';

function App() {
  return (
    <>
      <ToastContainer />
      {/* <EmailForm /> */}
      <Router>
        <Switch>
          <Route exact path='/'>
            <HomePage />
          </Route>
           <Route path='/sip'>
            <SipPage />
          </Route>
          <Route path='/comingsoon'>
            <ComingSoon />
          </Route>
           <Route path='/trustee-certificate'>
            <TrusteeCertificate />
          </Route>
          <Route path='/price-charts'>
            <ChartComponent />
          </Route>
           <Route path='/faq'>
            <NewFaqPage />
          </Route>
        </Switch>
      </Router>
    </>
  );
}

export default App;
